import React from 'react';
import { COLORS } from '../../constants/colors';

const ActionCard = ({ icon: Icon, title, description, buttonText, onClick, gradientIcon, gradientBtn, disabled = false, variant = 'solid', comingSoon = false }) => {
  // Solid color styles using your brand purple
  const getIconStyle = () => {
    if (gradientIcon.includes('purple-500')) {
      return { backgroundColor: COLORS.purple }; // Solid brand purple
    }
    return {};
  };

  const getButtonStyle = () => {
    if (gradientBtn.includes('purple-500')) {
      return { backgroundColor: COLORS.purple }; // Solid brand purple
    }
    return {};
  };

  return (
    <div className="flex-1 bg-white rounded-lg shadow-md p-4 border border-gray-300">
      <div className="flex items-start gap-3 mb-3">
        <div 
          className={`w-10 h-10 rounded-full flex items-center justify-center ${!gradientIcon.includes('purple-500') ? gradientIcon : ''}`}
          style={getIconStyle()}
        >
          <Icon className="w-5 h-5 text-white" />
        </div>
        <h3 className="text-medium font-semibold text-gray-900">{title}</h3>
      </div>

      {comingSoon && <p className="text-xs font-semibold text-orange-600 mb-1">Coming Soon:</p>}
      <p className="text-xs text-gray-600 mb-3">{description}</p>

      <button
        onClick={!disabled ? onClick : null}
        disabled={disabled}
        className={`w-full text-xs py-2 px-3 rounded-lg font-medium transition-all flex items-center justify-center gap-2 border ${
          disabled
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed border-gray-300'
            : variant === 'outline'
              ? 'bg-white text-gray-700 hover:bg-gray-50 border-gray-300'
              : gradientBtn.includes('purple-500') ? 'text-white hover:opacity-90' : `${gradientBtn} text-white hover:opacity-90`
        }`}
        style={!disabled && variant !== 'outline' ? getButtonStyle() : {}}
      >
        <Icon 
          className={`w-4 h-4 ${disabled ? 'text-gray-400' : variant === 'outline' ? '' : 'text-white'}`}
          style={!disabled && variant === 'outline' ? { color: COLORS.purple } : {}}
        />
        {buttonText}
      </button>
    </div>
  );
};

export default ActionCard;
